import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { DialogTitle } from 'Views/Page/Content/Modal/Components';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { FDHeadlineText, FDTitleText } from '@facet-wealth/design';

export default buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => DialogTitle,
  }, overrideReadOnly)
  .nameOverride('disclaimer', {
    _component: () => Richtext,
    _customProps: {
      align: 'center',
      color: 'textDisabled',
      size: 'sm',
    },
  }, overrideReadOnly);

export const offerMetaOverrideSet = buildFacetDesignOverride()
  .nameOverride('headline', {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'lg' },
  }, overrideReadOnly)
  .nameOverride('headlineFinePrint', {
    _component: () => Text,
    _customProps: { Component: FDTitleText, size: 'lg' },
  }, overrideReadOnly);
